module.exports = __webpack_public_path__ + "img/chevron-up-sharp-light.fee59432.svg";